document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-slide]'));
    const dots = Array.from(slider.querySelectorAll('[data-slide-dot]'));
    const prev = slider.querySelector('[data-slide-prev]');
    const next = slider.querySelector('[data-slide-next]');
    if (!slides.length) return;

    let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
    if (index < 0) index = 0;
    let timer = null;
    let isPaused = false;
    const toggle = slider.querySelector('[data-slide-toggle]');

    const updateAspect = () => {
      const activeSlide = slides[index];
      const bannerSlide = slides.find((slide) => slide.classList.contains('hero-slide--banner'));
      const mobileView = window.matchMedia('(max-width: 520px)').matches;
      let aspectAttr = mobileView
        ? (activeSlide?.getAttribute('data-aspect-mobile') || activeSlide?.getAttribute('data-aspect') || '0.78')
        : (activeSlide?.getAttribute('data-aspect') || '2.25');
      if (activeSlide?.classList.contains('hero-slide--split') && bannerSlide) {
        aspectAttr = mobileView
          ? (bannerSlide.getAttribute('data-aspect-mobile') || bannerSlide.getAttribute('data-aspect') || '0.78')
          : (bannerSlide.getAttribute('data-aspect') || '2.38');
      }
      const aspect = parseFloat(aspectAttr);
      if (aspect && Number.isFinite(aspect)) {
        slider.style.setProperty('--hero-active-ratio', String(aspect));
      }
    };

    const show = (newIndex) => {
      index = (newIndex + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      updateAspect();
    };

    const start = () => {
      if (isPaused || slider.dataset.autoplay !== 'true' || slides.length < 2) return;
      stop();
      const speed = Number(slider.dataset.speed || 5000);
      timer = window.setInterval(() => show(index + 1), speed);
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const restartAutoplay = () => {
      if (!isPaused) start();
    };

    prev?.addEventListener('click', () => { show(index - 1); restartAutoplay(); });
    toggle?.addEventListener('click', () => {
      isPaused = !isPaused;
      slider.classList.toggle('is-paused', isPaused);
      toggle.setAttribute('aria-label', isPaused ? 'Play slideshow' : 'Pause slideshow');
      if (isPaused) stop(); else start();
    });
    next?.addEventListener('click', () => { show(index + 1); restartAutoplay(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); restartAutoplay(); }));
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', start);

    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoved = false;
    let isDragging = false;
    let dragNeighborIndex = -1;
    let dragDeltaX = 0;
    const mobileSwipeQuery = window.matchMedia('(max-width: 520px)');
    const swipeThreshold = 42;
    const verticalTolerance = 60;
    const dragStartThreshold = 12;
    const dragDurationMs = 260;

    const clearDragStyles = () => {
      slider.classList.remove('is-dragging');
      slides.forEach((slide) => {
        slide.classList.remove('is-drag-preview');
        slide.style.transform = '';
        slide.style.transition = '';
      });
      dragNeighborIndex = -1;
      dragDeltaX = 0;
      isDragging = false;
    };

    const applyDragPositions = (deltaX) => {
      const width = slider.clientWidth || 1;
      const direction = deltaX < 0 ? 1 : -1;
      const neighborIndex = (index + direction + slides.length) % slides.length;
      const activeSlide = slides[index];
      const neighborSlide = slides[neighborIndex];

      if (!activeSlide || !neighborSlide) return;

      slider.classList.add('is-dragging');
      if (dragNeighborIndex !== neighborIndex) {
        slides.forEach((slide, i) => {
          if (i !== index && i !== neighborIndex) {
            slide.classList.remove('is-drag-preview');
            slide.style.transform = '';
            slide.style.transition = '';
          }
        });
        dragNeighborIndex = neighborIndex;
      }

      neighborSlide.classList.add('is-drag-preview');
      activeSlide.style.transition = 'none';
      neighborSlide.style.transition = 'none';
      activeSlide.style.transform = `translate3d(${deltaX}px, 0, 0)`;
      neighborSlide.style.transform = `translate3d(${deltaX + (direction * width)}px, 0, 0)`;
      dragDeltaX = deltaX;
    };

    const settleDrag = (commitDirection) => {
      const width = slider.clientWidth || 1;
      const activeSlide = slides[index];
      const neighborSlide = dragNeighborIndex >= 0 ? slides[dragNeighborIndex] : null;
      if (!activeSlide) {
        clearDragStyles();
        return;
      }

      activeSlide.style.transition = `transform ${dragDurationMs}ms cubic-bezier(.22,.61,.36,1)`;
      if (neighborSlide) {
        neighborSlide.style.transition = `transform ${dragDurationMs}ms cubic-bezier(.22,.61,.36,1)`;
      }

      if (commitDirection && neighborSlide) {
        const direction = commitDirection;
        activeSlide.style.transform = `translate3d(${direction * -width}px, 0, 0)`;
        neighborSlide.style.transform = 'translate3d(0, 0, 0)';
        window.setTimeout(() => {
          clearDragStyles();
          show(index + direction);
          restartAutoplay();
        }, dragDurationMs);
      } else {
        activeSlide.style.transform = 'translate3d(0, 0, 0)';
        if (neighborSlide) {
          const direction = dragDeltaX < 0 ? 1 : -1;
          neighborSlide.style.transform = `translate3d(${direction * width}px, 0, 0)`;
        }
        window.setTimeout(() => {
          clearDragStyles();
          show(index);
          restartAutoplay();
        }, dragDurationMs);
      }
    };

    slider.addEventListener('touchstart', (event) => {
      if (!mobileSwipeQuery.matches || !event.touches.length) return;
      const touch = event.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchMoved = false;
      isDragging = false;
      dragNeighborIndex = -1;
      dragDeltaX = 0;
      stop();
    }, { passive: true });

    slider.addEventListener('touchmove', (event) => {
      if (!mobileSwipeQuery.matches || !event.touches.length) return;
      const touch = event.touches[0];
      const diffX = touch.clientX - touchStartX;
      const diffY = touch.clientY - touchStartY;
      if (Math.abs(diffX) > 8) touchMoved = true;
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > dragStartThreshold) {
        event.preventDefault();
        isDragging = true;
        applyDragPositions(diffX);
      }
    }, { passive: false });

    slider.addEventListener('touchend', (event) => {
      if (!mobileSwipeQuery.matches) return;
      const touch = event.changedTouches?.[0];
      const deltaX = touch ? (touch.clientX - touchStartX) : dragDeltaX;
      const deltaY = touch ? (touch.clientY - touchStartY) : 0;

      if (!isDragging) {
        restartAutoplay();
        return;
      }

      if (Math.abs(deltaY) > verticalTolerance) {
        settleDrag(0);
        return;
      }

      if (Math.abs(deltaX) >= swipeThreshold) {
        settleDrag(deltaX < 0 ? 1 : -1);
      } else {
        settleDrag(0);
      }
    }, { passive: true });

    slider.addEventListener('touchcancel', () => {
      if (!mobileSwipeQuery.matches || !isDragging) return;
      settleDrag(0);
    }, { passive: true });

    show(index);
    start();
    window.addEventListener('resize', updateAspect, { passive: true });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImages = Array.from(gallery.querySelectorAll('[data-main-image]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    const counter = gallery.querySelector('[data-gallery-counter]');
    if (!mainImages.length || !thumbs.length) return;

    const showImage = (mediaId) => {
      if (!mediaId) return;
      mainImages.forEach((img) => {
        img.classList.toggle('is-active', img.getAttribute('data-media-id') === mediaId);
      });
      thumbs.forEach((item) => {
        item.classList.toggle('is-active', item.getAttribute('data-media-id') === mediaId);
      });
      dots.forEach((item) => {
        item.classList.toggle('is-active', item.getAttribute('data-media-id') === mediaId);
      });
      const activeIndex = mainImages.findIndex((img) => img.getAttribute('data-media-id') === mediaId);
      if (counter && activeIndex >= 0) counter.textContent = (activeIndex + 1) + ' / ' + mainImages.length;
    };

    // Warm browser cache immediately for snappier switching.
    mainImages.forEach((img) => {
      const preload = new Image();
      preload.decoding = 'async';
      preload.src = img.currentSrc || img.src;
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showImage(thumb.getAttribute('data-media-id')));
      thumb.addEventListener('mouseenter', () => showImage(thumb.getAttribute('data-media-id')));
    });
    dots.forEach((dot) => dot.addEventListener('click', () => showImage(dot.getAttribute('data-media-id'))));

    const stage = gallery.querySelector('.product-gallery__main-wrap');
    let touchStartX = 0;
    stage?.addEventListener('touchstart', (event) => { touchStartX = event.touches[0]?.clientX || 0; }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const endX = event.changedTouches[0]?.clientX || touchStartX;
      const delta = endX - touchStartX;
      if (Math.abs(delta) < 45) return;
      const current = Math.max(0, mainImages.findIndex((img) => img.classList.contains('is-active')));
      const next = (current + (delta < 0 ? 1 : -1) + mainImages.length) % mainImages.length;
      showImage(mainImages[next].getAttribute('data-media-id'));
    }, { passive: true });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('[data-search-modal]');
  const openers = document.querySelectorAll('.js-open-search');
  const closers = document.querySelectorAll('[data-search-close]');
  const input = modal?.querySelector('input[name="q"]');
  let searchCloseTimer;
  const setSearchPosition = () => {
    if (!modal) return;
    if (window.matchMedia('(max-width: 768px)').matches) {
      const header = document.querySelector('[data-site-header]');
      modal.style.setProperty('--search-top', Math.max(0, header?.getBoundingClientRect().bottom || 0) + 'px');
    } else {
      modal.style.removeProperty('--search-top');
    }
  };
  const openModal = () => {
    if (!modal) return;
    window.clearTimeout(searchCloseTimer);
    setSearchPosition();
    modal.hidden = false;
    document.body.classList.add('search-open');
    openers.forEach((opener) => opener.setAttribute('aria-expanded', 'true'));
    window.requestAnimationFrame(() => modal.classList.add('is-open'));
    window.setTimeout(() => input?.focus(), 180);
  };
  const closeModal = () => {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('search-open');
    openers.forEach((opener) => opener.setAttribute('aria-expanded', 'false'));
    searchCloseTimer = window.setTimeout(() => { modal.hidden = true; }, 220);
  };
  openers.forEach((el) => el.addEventListener('click', (e) => {
    e.preventDefault();
    if (!modal?.hidden && modal?.classList.contains('is-open')) closeModal();
    else openModal();
  }));
  closers.forEach((el) => el.addEventListener('click', closeModal));
  window.addEventListener('resize', () => { if (!modal?.hidden) setSearchPosition(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeModal();
  });

  const accountPanel = document.querySelector('[data-account-panel]');
  const wishlistPanel = document.querySelector('[data-wishlist-panel]');
  const syncAccountPanels = () => {
    if (!accountPanel || !wishlistPanel) return;
    const showWishlist = window.location.hash === '#wishlist';
    accountPanel.hidden = showWishlist;
    wishlistPanel.hidden = !showWishlist;
    document.querySelectorAll('[data-account-tab]').forEach((el) => {
      const target = el.getAttribute('href');
      el.classList.toggle('is-active', (showWishlist && target === '#wishlist') || (!showWishlist && target === '#dashboard'));
    });
  };
  syncAccountPanels();
  window.addEventListener('hashchange', syncAccountPanels);
});


document.addEventListener('DOMContentLoaded', () => {
  const announcement = document.querySelector('.announcement-bar--top');
  const announcementTrack = announcement?.querySelector('.announcement-bar__track') || announcement;
  const header = document.querySelector('[data-site-header]');
  const headerTopWrap = document.querySelector('[data-header-top-wrap]');
  const headerTop = document.querySelector('.site-header__top');
  const headerNavWrap = document.querySelector('[data-header-nav-wrap]');
  const mainContent = document.getElementById('MainContent');
  if (!header || !headerTopWrap || !headerNavWrap || !mainContent) return;

  /* ============================================================
     TODO FUN - Sticky header controller (rev. 2026-04-18)
     ============================================================
     Design notes for future-me:
     - avoid set inline height/maxHeight on headerTopWrap at rest.
       Natural CSS flow handles the at-rest size; locking an inline
       height at DOMContentLoaded (before fonts/logo load) was the
       root cause of the "squished/tangled menubar on load" bug.
     - Measurements (ann/top/nav heights) live in CSS custom
       properties on the header, and MainContent padding is driven
       by them. CSS owns layout, JS owns state.
     - A ResizeObserver catches late relayouts (webfont swap, logo
       image finishing, viewport resize) and re-syncs the vars.
     - Collapse/expand is animated via CSS transitions keyed off
       a [data-state] attribute on the header.
     ============================================================ */

  let state = 0; // 0 = full, 1 = ann hidden, 2 = ann + top hidden
  let lastY = window.scrollY || 0;
  let downAccum = 0;
  let upAccum = 0;
  const announcementStep = 90;
  const headerStep = 320;
  const restoreStep = 120;

  const measureHeight = (el) => {
    if (!el) return 0;
    const rect = el.getBoundingClientRect();
    return Math.round(rect.height || el.offsetHeight || 0);
  };

  // Sync CSS custom properties with the real measured sizes, and update
  // the "current" vars based on current collapse state. CSS drives the
  // actual visual layout from these vars + body classes. JS never sets
  // inline height/maxHeight on the wrap itself (that was the squish bug).
  const syncSizes = () => {
    const annFull = measureHeight(announcementTrack);
    const topFull = measureHeight(headerTop);
    const navFull = measureHeight(headerNavWrap);
    const root = document.documentElement;
    root.style.setProperty('--announcement-visible-height', `${annFull}px`);
    root.style.setProperty('--header-top-visible-height', `${topFull}px`);
    root.style.setProperty('--header-nav-visible-height', `${navFull}px`);
    const annCurrent = state >= 1 ? 0 : annFull;
    const topCurrent = state >= 2 ? 0 : topFull;
    root.style.setProperty('--announcement-current-height', `${annCurrent}px`);
    root.style.setProperty('--header-top-current-height', `${topCurrent}px`);
  };

  // Toggle body classes that the CSS uses to drive collapse animations.
  const applyState = () => {
    document.body.classList.toggle('announcement-hidden', state >= 1);
    document.body.classList.toggle('header-top-hidden', state >= 2);
  };

  const render = () => {
    syncSizes();
    applyState();
  };

  const resetAtTop = () => {
    if (state !== 0) {
      state = 0;
      render();
    }
    downAccum = 0;
    upAccum = 0;
  };

  let ticking = false;
  const onScroll = () => {
    const y = window.scrollY || 0;
    if (y <= 2) {
      lastY = y;
      resetAtTop();
      ticking = false;
      return;
    }

    const delta = y - lastY;
    lastY = y;

    if (Math.abs(delta) < 2) {
      ticking = false;
      return;
    }

    if (delta > 0) {
      downAccum += delta;
      upAccum = 0;
      if (state === 0 && downAccum >= announcementStep) {
        state = 1;
        downAccum = 0;
        render();
      } else if (state === 1 && downAccum >= headerStep) {
        state = 2;
        downAccum = 0;
        render();
      }
    } else {
      upAccum += Math.abs(delta);
      downAccum = 0;
      if (state === 2 && upAccum >= restoreStep) {
        state = 1;
        upAccum = 0;
        render();
      } else if (state === 1 && upAccum >= restoreStep) {
        state = 0;
        upAccum = 0;
        render();
      }
    }

    ticking = false;
  };

  // Initial paint (may use under-measured values, that's fine - we re-sync).
  render();

  // The main content's top padding is animated so the header can fold while
  // you scroll. On the very first paint that transition is not a feature: the
  // CSS fallbacks are a guess, this render is the correction, and the page was
  // visibly sliding up by the difference every single load. Enable it only
  // after the real measurement has been painted.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => document.documentElement.classList.add('header-measured'));
  });

  // 1. Re-sync when webfonts finish loading (biggest single cause of squish).
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncSizes).catch(() => {});
  }

  // 2. Re-sync when any header image (logo, icons) finishes loading.
  header.querySelectorAll('img').forEach((img) => {
    if (!img.complete) img.addEventListener('load', syncSizes, { once: true });
  });

  // 3. Re-sync on full window load (catches anything else async).
  window.addEventListener('load', syncSizes);

  // 4. ResizeObserver is the real workhorse - catches any layout shift
  //    in the header (fonts swap, image dimensions resolve, responsive
  //    breakpoints, viewport resize) and auto-syncs.
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(() => syncSizes());
    if (announcementTrack) ro.observe(announcementTrack);
    ro.observe(headerTop);
    ro.observe(headerNavWrap);
  }

  // 5. Classic resize fallback.
  window.addEventListener('resize', syncSizes);

  // 6. Scroll handler (state machine).
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
});


document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-mobile-menu]');
  if (!drawer) return;
  const openers = document.querySelectorAll('[data-mobile-menu-open]');
  const closers = drawer.querySelectorAll('[data-mobile-menu-close]');
  const tabs = drawer.querySelectorAll('[data-mobile-menu-tab]');
  const panels = drawer.querySelectorAll('[data-mobile-menu-panel]');
  const open = () => { drawer.hidden = false; document.body.classList.add('mobile-menu-open'); };
  const close = () => { drawer.hidden = true; document.body.classList.remove('mobile-menu-open'); };
  openers.forEach(btn => btn.addEventListener('click', open));
  closers.forEach(btn => btn.addEventListener('click', close));
  tabs.forEach((tab) => tab.addEventListener('click', () => {
    const key = tab.getAttribute('data-mobile-menu-tab');
    tabs.forEach(t => t.classList.toggle('is-active', t === tab));
    panels.forEach(p => p.classList.toggle('is-active', p.getAttribute('data-mobile-menu-panel') === key));
  }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
});

/* ============================================================
   TODO FUN - Conversion pack (sticky ATC, cart drawer, trust)
   ============================================================ */
(function () {
  const money = (cents, format) => {
    // Fallback money formatter. Shopify exposes theme_settings.money_format via Liquid;
    // for JS we use Intl.NumberFormat USD as a close-enough default.
    const v = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(v);
    } catch (_) {
      return '$' + v.toFixed(2);
    }
  };

  /* ---------- Variant sync: price + stock + availability ---------- */
  function initVariantSync() {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;
    const select = section.querySelector('[data-variant-select]');
    const priceEl = section.querySelector('[data-product-price]');
    const stickyPriceEl = document.querySelector('[data-sticky-price]');
    const stockEl = section.querySelector('[data-stock-indicator]');
    const atcLabel = section.querySelector('[data-atc-label]');
    const atcBtn = section.querySelector('[data-atc-button]');
    const stickyBtn = document.querySelector('[data-sticky-atc-button]');
    const pickerSheet = section.querySelector('[data-vpick-sheet]');
    const pickerOpen = section.querySelector('[data-vpick-open]');
    const summaryName = section.querySelector('[data-vpick-summary-name]');
    const summaryPrice = section.querySelector('[data-vpick-summary-price]');
    const summaryVisual = section.querySelector('[data-vpick-summary-visual]');
    const summaryEyebrow = section.querySelector('[data-vpick-summary-eyebrow]');
    const summaryAction = section.querySelector('[data-vpick-summary-action]');
    const sheetEyebrow = section.querySelector('[data-vpick-sheet-eyebrow]');
    const sheetTitle = section.querySelector('[data-vpick-sheet-title]');
    const sheetDone = section.querySelector('[data-vpick-done]');
    if (!select) return;

    const threshold = parseInt(stockEl?.dataset.stockThreshold || '10', 10);

    const sync = () => {
      const opt = select.options[select.selectedIndex];
      const price = parseInt(opt.dataset.price, 10);
      const inv = parseInt(opt.dataset.inventory, 10);
      const invManaged = opt.dataset.inventoryManaged === '1';
      const available = opt.dataset.available === 'true';

      if (priceEl) priceEl.textContent = money(price);
      if (stickyPriceEl) stickyPriceEl.textContent = money(price);
      // meter is driven by the quantity-aware refreshMeter() below

      if (stockEl) {
        if (invManaged && available && inv > 0 && inv <= threshold) {
          stockEl.textContent = 'Low stock';
          stockEl.classList.add('product-stock--low');
          stockEl.style.display = '';
        } else {
          stockEl.style.display = 'none';
        }
      }

      const label = available ? 'Add to cart' : 'Sold out';
      if (atcLabel) atcLabel.textContent = label;
      if (atcBtn) atcBtn.disabled = !available;
      if (stickyBtn) { stickyBtn.textContent = label; stickyBtn.disabled = !available; }
      if (summaryPrice) summaryPrice.textContent = money(price);
    };

    const openPicker = (mode = 'modal') => {
      if (!pickerSheet) return;
      const panel = pickerSheet.querySelector('.vpick-sheet__panel');
      const inline = mode === 'inline';
      pickerSheet.classList.toggle('is-inline', inline);
      pickerSheet.classList.toggle('is-open', !inline);
      pickerSheet.setAttribute('aria-hidden', 'false');
      pickerOpen?.setAttribute('aria-expanded', 'true');
      document.body.classList.toggle('variant-sheet-open', !inline);
      if (panel) {
        panel.setAttribute('role', inline ? 'group' : 'dialog');
        if (inline) panel.removeAttribute('aria-modal');
        else panel.setAttribute('aria-modal', 'true');
      }
      if (inline && summaryAction) summaryAction.textContent = 'Close styles';
      const selected = pickerSheet.querySelector('.is-selected');
      if (!inline && panel && selected) panel.scrollTop = Math.max(0, selected.offsetTop - 100);
    };
    const closePicker = () => {
      if (!pickerSheet) return;
      pickerSheet.classList.remove('is-open');
      pickerSheet.classList.remove('is-inline');
      pickerSheet.setAttribute('aria-hidden', 'true');
      pickerOpen?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('variant-sheet-open');
      if (summaryAction) summaryAction.textContent = window.TFPack?.active ? 'Edit styles' : 'Change style';
      pickerOpen?.focus();
    };
    pickerOpen?.addEventListener('click', () => {
      if (window.TFPack?.active) {
        openPicker('modal');
      } else if (pickerSheet?.classList.contains('is-inline')) {
        closePicker();
      } else {
        openPicker('inline');
      }
    });
    section.querySelectorAll('[data-vpick-close]').forEach((button) => button.addEventListener('click', closePicker));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && pickerSheet?.classList.contains('is-open')) closePicker(); });

    select.addEventListener('change', sync);

    // Visible option buttons drive the native select so all downstream logic is untouched
    const opts = section.querySelectorAll('[data-vpick-opt]');
    opts.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-oos')) return;
        select.value = btn.dataset.variantId;
        opts.forEach((b) => {
          const on = b === btn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        // swap the gallery to this variant's image if one is assigned
        const mediaId = btn.dataset.variantMedia;
        if (mediaId) {
          const gallery = document.querySelector('[data-product-gallery]');
          if (gallery) {
            gallery.querySelectorAll('[data-main-image]').forEach((img) => {
              img.classList.toggle('is-active', img.dataset.mediaId === mediaId);
            });
            gallery.querySelectorAll('[data-thumb]').forEach((t) => {
              t.classList.toggle('is-active', t.dataset.mediaId === mediaId);
            });
          }
        }
        select.dispatchEvent(new Event('change', { bubbles: true }));
        if (summaryName) summaryName.textContent = btn.querySelector('.vpick__name')?.textContent || '';
        if (summaryVisual) {
          const source = btn.querySelector('.vpick__thumb');
          summaryVisual.innerHTML = source ? '<img src="' + source.src + '" alt="" width="64" height="64">' : '';
        }
        if (pickerSheet && !(window.TFPack && window.TFPack.active)) closePicker();
      });
    });

    // Volume tiers: set quantity, show per-unit price, keep the discount honest    // ---- Volume tiers + quantity, kept in lock-step with the ship meter ----
    const qtyInput = section.querySelector('[data-qty-input]');
    const tierWrap = document.querySelector('[data-vtiers]');
    const pctFor = (q) => (q >= 3 ? 0.15 : q === 2 ? 0.10 : 0);

    const currentQty = () => parseInt(qtyInput?.value || '1', 10) || 1;
    const unitCents = () => parseInt(select.options[select.selectedIndex].dataset.price, 10) || 0;

    // the meter should reflect what the shopper will actually pay
    const refreshMeter = () => {
      const q = currentQty();
      const gross = unitCents() * q;
      ShipMeter.setProductVariantCents(Math.round(gross * (1 - pctFor(q))));
    };

    if (tierWrap) {
      const step = tierWrap.querySelector('[data-vstep]');
      const stepVal = tierWrap.querySelector('[data-vstep-value]');
      const tiers = tierWrap.querySelectorAll('[data-vtier-qty]');
      const multiVariant = select.options.length > 1;

      const setQty = (q) => {
        q = Math.max(1, Math.min(99, q));
        if (qtyInput) qtyInput.value = q;
        if (stepVal) stepVal.textContent = q;
        tiers.forEach((x) => {
          const tq = parseInt(x.dataset.vtierQty, 10);
          x.classList.toggle('is-active', tq === 3 ? q >= 3 : tq === q);
        });
        if (step) step.hidden = q < 3;
        if (window.TFPack) {
          // dropping to a smaller pack must not leave more chosen than allowed
          if (window.TFPack.active && window.TFPack.trimTo) window.TFPack.trimTo(q);
          if (window.TFPack.setMode) window.TFPack.setMode(q > 1);
        }
        refreshMeter();
      };

      const paintEach = () => {
        const base = unitCents();
        tierWrap.querySelectorAll('[data-tier-each]').forEach((el) => {
          const q = parseInt(el.dataset.tierEach, 10);
          el.textContent = money(Math.round(base * (1 - pctFor(q)))) + ' each';
        });
      };

      // ---- Mix and match: a 3-pack of the same cat defeats the point of 7 cats ----
      const packBar = section.querySelector('[data-packbar]');
      const pickWrap = section.querySelector('[data-vpick]');
      const haveEl = section.querySelector('[data-pack-have]');
      const needEl = section.querySelector('[data-pack-need]');
      window.TFPack = { active: false, counts: {} };

      const packTotal = () => Object.values(window.TFPack.counts).reduce((a, b) => a + b, 0);

      const paintPack = () => {
        const need = currentQty();
        if (needEl) needEl.textContent = need;
        if (haveEl) haveEl.textContent = packTotal();
        opts.forEach((b) => {
          const c = window.TFPack.counts[b.dataset.variantId] || 0;
          b.classList.toggle('has-count', c > 0);
          let badge = b.querySelector('.vpick__count');
          if (c > 0) {
            if (!badge) { badge = document.createElement('span'); badge.className = 'vpick__count'; b.appendChild(badge); }
            badge.textContent = c;
          } else if (badge) badge.remove();
        });
        const have = packTotal();
        const ready = have === need;
        if (summaryName && window.TFPack.active) summaryName.textContent = have + ' of ' + need + ' styles selected';
        if (summaryAction && window.TFPack.active) summaryAction.textContent = ready ? 'Edit styles' : 'Choose styles';
        if (sheetDone) {
          sheetDone.disabled = window.TFPack.active && !ready;
          sheetDone.textContent = window.TFPack.active && !ready ? 'Choose ' + (need - have) + ' more' : 'Done';
        }
        if (atcBtn) atcBtn.disabled = window.TFPack.active && !ready;
        if (atcLabel && window.TFPack.active) {
          if (ready) atcLabel.textContent = 'Add ' + need + ' to cart';
          else if (have > need) atcLabel.textContent = 'Remove ' + (have - need);
          else atcLabel.textContent = 'Choose ' + (need - have) + ' more';
        }
      };

      window.TFPack.trimTo = (limit) => {
        let total = packTotal();
        if (total <= limit) return;
        for (const id of Object.keys(window.TFPack.counts)) {
          while (total > limit && window.TFPack.counts[id] > 0) {
            window.TFPack.counts[id] -= 1; total -= 1;
          }
          if (window.TFPack.counts[id] === 0) delete window.TFPack.counts[id];
          if (total <= limit) break;
        }
      };

      window.TFPack.setMode = (on) => {
        window.TFPack.active = on && multiVariant;
        if (packBar) packBar.hidden = !window.TFPack.active;
        if (pickWrap) pickWrap.classList.toggle('vpick--pack', window.TFPack.active);
        if (summaryEyebrow) summaryEyebrow.textContent = window.TFPack.active ? 'Pack selection' : 'Selected style';
        if (sheetEyebrow) sheetEyebrow.textContent = window.TFPack.active ? 'Build your pack' : 'Choose your';
        if (sheetTitle) sheetTitle.textContent = window.TFPack.active ? 'Choose ' + currentQty() + ' styles' : 'Style';
        if (!window.TFPack.active) {
          window.TFPack.counts = {};
          opts.forEach((b) => { b.classList.remove('has-count'); b.querySelector('.vpick__count')?.remove(); });
          if (atcBtn) atcBtn.disabled = false;
          if (atcLabel) atcLabel.textContent = 'Add to cart';
          if (summaryAction) summaryAction.textContent = 'Change style';
          if (sheetDone) { sheetDone.disabled = false; sheetDone.textContent = 'Done'; }
        }
        paintPack();
      };

      tiers.forEach((t) => t.addEventListener('click', () => {
        const q = parseInt(t.dataset.vtierQty, 10);
        setQty(q);
        if (q > 1 && multiVariant) openPicker('modal');
      }));

      opts.forEach((b) => {
        b.addEventListener('click', (e) => {
          if (!window.TFPack.active || b.classList.contains('is-oos')) return;
          e.stopImmediatePropagation();
          const id = b.dataset.variantId;
          const need = currentQty();
          const cur = window.TFPack.counts[id] || 0;
          if (e.target.classList.contains('vpick__count')) {
            window.TFPack.counts[id] = Math.max(0, cur - 1);
          } else if (packTotal() < need) {
            window.TFPack.counts[id] = cur + 1;
          }
          paintPack();
        }, true);
      });

      section.querySelector('[data-pack-clear]')?.addEventListener('click', () => {
        window.TFPack.counts = {}; paintPack();
      });
      tierWrap.querySelector('[data-vstep-minus]')?.addEventListener('click', () => setQty(currentQty() - 1));
      tierWrap.querySelector('[data-vstep-plus]')?.addEventListener('click', () => setQty(currentQty() + 1));

      select.addEventListener('change', () => { paintEach(); refreshMeter(); });
      paintEach();
      setQty(1);
    } else {
      select.addEventListener('change', refreshMeter);
      refreshMeter();
    }

    sync();
  }

  /* ---------- Sticky ATC: show once main ATC scrolls off ---------- */
  function initStickyATC() {
    const bar = document.querySelector('[data-sticky-atc]');
    const mainBtn = document.querySelector('[data-atc-button]');
    const stickyBtn = document.querySelector('[data-sticky-atc-button]');
    const form = document.querySelector('[data-product-form]');
    if (!bar || !mainBtn || !form) return;

    const obs = new IntersectionObserver((entries) => {
      const e = entries[0];
      // Show the fallback only after the shopper has scrolled past the real
      // purchase button. A button that is still below the viewport must not
      // trigger a competing CTA on first load.
      const show = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { threshold: 0, rootMargin: '0px' });
    obs.observe(mainBtn);

    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        // Submit via fetch so we can open the drawer instead of navigating.
        const fd = new FormData(form);
        fd.set('quantity', '1');
        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json' },
        }).then(r => r.json()).then(() => {
          CartDrawer.refresh().then(() => CartDrawer.open());
        }).catch(() => { form.submit(); });
      });
    }
  }

  /* ---------- Intercept main ATC to open drawer ---------- */
  function initAjaxATC() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      // pack mode: post every chosen variant in one request
      if (window.TFPack && window.TFPack.active) {
        const items = Object.entries(window.TFPack.counts)
          .filter(([, q]) => q > 0)
          .map(([id, q]) => ({ id: Number(id), quantity: q }));
        if (!items.length) return;
        const b = form.querySelector('[data-atc-button]');
        if (b) b.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items }),
        }).then(r => r.json()).then(() => {
          if (window.TFBuyNow) { window.location.href = '/checkout'; return; }
          window.TFPack.setMode(false);
          const one = document.querySelector('[data-vtier-qty="1"]');
          if (one) one.click();
          CartDrawer.refresh().then(() => CartDrawer.open());
        }).finally(() => { if (b) b.disabled = false; });
        return;
      }
      const btn = form.querySelector('[data-atc-button]');
      const label = btn?.querySelector('[data-atc-label]');
      const originalLabel = label?.textContent;
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding...';
      const fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' },
      }).then(r => {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      }).then(() => {
        // Buy now rides this same path so it inherits pack mode, the volume
        // tiers and the variant picker instead of re-deriving them. The only
        // difference is where it lands.
        if (window.TFBuyNow) { window.location.href = '/checkout'; return null; }
        return CartDrawer.refresh();
      }).then(() => {
        if (window.TFBuyNow) return;
        if (label) label.textContent = 'Added ✓';
        CartDrawer.open();
        setTimeout(() => {
          if (btn) btn.disabled = false;
          if (label && originalLabel) label.textContent = originalLabel;
        }, 1200);
      }).catch(() => {
        window.TFBuyNow = false;
        if (btn) btn.disabled = false;
        if (label && originalLabel) label.textContent = originalLabel;
        form.submit();
      });
    });
  }

  /* ---------- Shared ship meter (single source of truth) ----------
     Reads threshold from each meter's data-threshold-cents (set by snippet from theme settings).
     Updates product meter (variant-aware + cart-aware) and cart/drawer meters (cart-total only).
  ---------------------------------------------------------------- */
  const ShipMeter = (() => {
    let cachedCartTotalCents = null; // last known cart.total_price

    function formatMoney(cents) {
      // Use same money helper defined later in file
      return money(cents);
    }

    function renderMeter(el, cents, thresholdCents) {
      if (thresholdCents <= 0) { el.style.display = 'none'; return; }
      const unlocked = cents >= thresholdCents;
      const remaining = Math.max(0, thresholdCents - cents);
      const pct = Math.max(0, Math.min(100, Math.round((cents / thresholdCents) * 100)));

      el.classList.toggle('is-unlocked', unlocked);
      el.style.display = '';

      const textEl = el.querySelector('[data-ship-text]');
      const fillEl = el.querySelector('[data-ship-fill]');
      if (fillEl) fillEl.style.width = pct + '%';

      if (textEl) {
        if (unlocked) {
          const label = el.dataset.unlockedLabel || 'You unlocked free US shipping';
          textEl.innerHTML = '🎉 ' + label.replace(/free US shipping/i, '<strong>free US shipping</strong>');
        } else {
          const tmpl = el.dataset.progressLabel || '{amount} away from free US shipping';
          const amountHtml = '<strong>' + formatMoney(remaining) + '</strong>';
          textEl.innerHTML = tmpl.replace('{amount}', amountHtml);
        }
      }
    }

    function updateAll(cartTotalCents) {
      if (typeof cartTotalCents === 'number') cachedCartTotalCents = cartTotalCents;
      const cartCents = cachedCartTotalCents || 0;
      const meters = document.querySelectorAll('[data-ship-meter]');
      meters.forEach(el => {
        const threshold = parseInt(el.dataset.thresholdCents, 10) || 0;
        const ctx = el.dataset.shipContext || 'product';
        let cents;
        if (ctx === 'product') {
          // PDP shows THIS product's price vs threshold. Straight compare.
          // No cart total, no projection , shopper wants to know: "is this
          // one item enough to unlock free shipping?".
          cents = parseInt(el.dataset.productPriceCents, 10) || 0;
        } else {
          // Drawer / cart page: actual cart total.
          cents = cartCents;
        }
        renderMeter(el, cents, threshold);
      });
    }

    function setProductVariantCents(cents) {
      const el = document.querySelector('[data-ship-meter][data-ship-context="product"]');
      if (!el) return;
      el.dataset.productPriceCents = String(cents || 0);
      updateAll();
    }

    function hideDrawerMeter(hide) {
      const el = document.querySelector('[data-ship-meter][data-ship-context="drawer"]');
      if (el) el.style.display = hide ? 'none' : '';
    }

    function init() {
      // SSR already rendered; hydrate with live cart on first load.
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json()).then(c => updateAll(c.total_price || 0))
        .catch(() => updateAll(0));
    }

    return { updateAll, setProductVariantCents, hideDrawerMeter, init };
  })();

  /* ---------- Cart boost: free-gift threshold + one recommendation ----------
     Shared by the drawer and /cart so both carts offer the same thing.
     Markup comes from snippets/cart-boost.liquid; gift choices are theme
     settings, so what is on offer is editable without a deploy.
  --------------------------------------------------------------------------- */
  const CartBoost = (() => {
    let lastSeed = null;

    function afterChange(el) {
      // The /cart page is server-rendered per line item, so a new line needs a
      // reload. The drawer rebuilds itself from JSON.
      return el.closest('.cart-page')
        ? Promise.resolve(window.location.reload())
        : window.CartDrawer.refresh();
    }

    /* ---- Free gift ---- */
    // Best value on offer at a given rung, used to anchor the progress copy.
    function worthAt(box, cents) {
      let best = '';
      let bestNum = -1;
      box.querySelectorAll('[data-gift-opt]').forEach(o => {
        if (Number(o.dataset.minCents || 0) !== cents) return;
        const raw = (o.dataset.worth || '').replace(/[^0-9.]/g, '');
        const n = parseFloat(raw);
        if (!isNaN(n) && n > bestNum) { bestNum = n; best = o.dataset.worth; }
      });
      return best;
    }

    function isGiftLine(item) {
      const allocs = item.line_level_discount_allocations || [];
      if (allocs.some(a => ((a.discount_application || {}).title || '')
          .toLowerCase().indexOf('free gift') === 0)) return true;
      return item.final_line_price === 0 && item.original_line_price > 0;
    }

    // Added through the gift picker but no longer free: the shopper dropped
    // back under the threshold and would otherwise be charged without noticing.
    function strandedGift(cart) {
      return (cart.items || []).find(i =>
        i.properties && i.properties._gift && !isGiftLine(i)) || null;
    }

    function giftIds() {
      const ids = new Set();
      document.querySelectorAll('[data-gift-opt]').forEach(o => ids.add(Number(o.dataset.productId)));
      return ids;
    }

    // Header gift chip: the only place the offer is visible before someone
    // opens the bag, so it carries the remaining amount rather than a bare icon.
    function renderChip(cart) {
      const chips = document.querySelectorAll('[data-gift-chip]');
      if (!chips.length) return;
      const box = document.querySelector('[data-cart-gift]');
      if (!box || !cart.items || !cart.items.length) {
        chips.forEach(c => { c.hidden = true; });
        return;
      }
      let spend = 0;
      let hasGift = false;
      cart.items.forEach(i => {
        if (isGiftLine(i)) hasGift = true;
        else spend += i.original_line_price;
      });
      const tiers = [box.dataset.tier1Cents, box.dataset.tier2Cents, box.dataset.tier3Cents]
        .map(Number).filter(n => n > 0).sort((a, b) => a - b);
      if (!tiers.length) { chips.forEach(c => { c.hidden = true; }); return; }
      const next = tiers.find(t => spend < t) || 0;

      // Free shipping is the nearer goal until it is met, and it is judged on
      // the charged total. Name the same milestone the drawer is counting to.
      const shipCents = Number(box.dataset.shipCents || 0);
      const charged = cart.total_price || 0;
      if (shipCents > 0 && charged < shipCents) {
        chips.forEach(c => {
          const t = c.querySelector('[data-gift-chip-text]');
          if (t) t.textContent = 'Add ' + money(shipCents - charged) + ' → free US shipping';
          c.classList.remove('is-unlocked');
          c.hidden = false;
        });
        return;
      }

      chips.forEach(c => {
        const t = c.querySelector('[data-gift-chip-text]');
        if (hasGift && !next) {
          if (t) t.textContent = 'Free gift added';
          c.classList.add('is-unlocked');
        } else if (next) {
          // A bare figure answered none of the questions a shopper has: what
          // is it, is it worth anything, does it benefit me. Name the reward.
          const unlockedAlready = spend >= tiers[0];
          const worth = worthAt(box, next);
          const gap = money(next - spend);
          if (t) {
            t.textContent = unlockedAlready
              ? (worth ? 'Add ' + gap + ' → free ' + worth + ' gift'
                       : 'Add ' + gap + ' → a bigger free gift')
              : (worth ? 'Add ' + gap + ' → free ' + worth + ' gift'
                       : 'Add ' + gap + ' → free gift');
          }
          c.classList.toggle('is-unlocked', unlockedAlready);
        } else {
          if (t) t.textContent = 'Claim your free gift';
          c.classList.add('is-unlocked');
        }
        c.hidden = false;
      });
    }

    function paintOpts(picker, spend) {
      picker.querySelectorAll('[data-gift-opt]').forEach(opt => {
        const min = Number(opt.dataset.minCents || 0);
        const locked = spend < min;
        opt.hidden = false;
        opt.classList.toggle('is-locked', locked);
        opt.disabled = locked;
        const need = opt.querySelector('[data-gift-opt-need]');
        if (need) need.textContent = locked ? money(min) + '+' : '';
        opt.onclick = locked ? null : () => chooseGift(opt.closest('[data-cart-gift]'), opt);
      });
    }

    function addGift(box, variantId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1,
                                       properties: { _gift: 'yes' } }] }),
      }).then(() => afterChange(box));
    }

    // Most gifts have a design to pick, so tapping a tile opens a variant step
    // rather than silently dropping a random one in the bag.
    function chooseGift(box, opt) {
      let variants = [];
      try { variants = JSON.parse(opt.dataset.variants || '[]'); } catch (e) { variants = []; }
      const usable = variants.filter(v => v.available);

      box.querySelectorAll('[data-gift-opt]').forEach(o => o.classList.toggle('is-picked', o === opt));

      if (usable.length < 2) {
        opt.disabled = true;
        return addGift(box, usable.length ? usable[0].id : opt.dataset.variantId)
          .catch(() => { opt.disabled = false; });
      }

      const panel = box.querySelector('[data-gift-choose]');
      const select = box.querySelector('[data-gift-variant-select]');
      const label = box.querySelector('[data-gift-choose-label]');
      if (!panel || !select) return addGift(box, opt.dataset.variantId);

      label.textContent = 'Pick your ' + (opt.dataset.optionName || 'design');
      select.innerHTML = usable.map(v =>
        '<option value="' + v.id + '">' + v.title + '</option>').join('');
      panel.hidden = false;

      const confirm = box.querySelector('[data-gift-confirm]');
      confirm.disabled = false;
      confirm.textContent = 'Add free gift';
      confirm.onclick = () => {
        confirm.disabled = true;
        confirm.textContent = 'Adding';
        addGift(box, select.value).catch(() => {
          confirm.disabled = false;
          confirm.textContent = 'Add free gift';
        });
      };
    }

    function renderGift(cart) {
      const blocks = document.querySelectorAll('[data-cart-gift]');
      if (!blocks.length) return;

      // Spend is measured on non-gift lines only, so the discount itself can
      // never drop the cart back under the threshold and yank the gift away.
      let spend = 0;
      let inBag = null;
      (cart.items || []).forEach(i => {
        if (isGiftLine(i)) { if (!inBag) inBag = i; }
        else spend += i.original_line_price;
      });
      const charged = cart.total_price || 0;

      blocks.forEach(box => {
        if (!cart.items || !cart.items.length) { box.hidden = true; return; }
        box.hidden = false;

        const tiers = [box.dataset.tier1Cents, box.dataset.tier2Cents, box.dataset.tier3Cents]
          .map(Number).filter(n => n > 0).sort((a, b) => a - b);
        const t1 = tiers[0] || 0;
        const shipCents = Number(box.dataset.shipCents || 0);
        const textEl = box.querySelector('[data-gift-text]');
        const fill = box.querySelector('[data-gift-fill]');
        const track = box.querySelector('[data-gift-track]');
        const picker = box.querySelector('[data-gift-picker]');
        const peek = box.querySelector('[data-gift-peek]');
        const chosen = box.querySelector('[data-gift-chosen]');
        const choose = box.querySelector('[data-gift-choose]');
        const unlocked = spend >= t1;

        const show = (el, on) => { if (el) el.hidden = !on; };

        // Already picked one: confirm it rather than keep selling.
        if (inBag) {
          show(track, false); show(picker, false); show(peek, false); show(choose, false);
          if (chosen) {
            chosen.hidden = false;
            const gimg = chosen.querySelector('[data-gift-chosen-img]');
            if (gimg) gimg.src = inBag.image ? inBag.image + '&width=120' : '';
            const gt = chosen.querySelector('[data-gift-chosen-title]');
            if (gt) gt.textContent = inBag.product_title;
            const swap = chosen.querySelector('[data-gift-swap]');
            if (swap) swap.onclick = () => {
              fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: inBag.key, quantity: 0 }),
              }).then(() => afterChange(box));
            };
          }
          if (textEl) textEl.textContent = 'Your free gift';
          box.classList.add('is-unlocked');
          return;
        }
        show(chosen, false);

        const stranded = strandedGift(cart);
        box.classList.toggle('is-stranded', !!stranded);
        box.classList.toggle('is-unlocked', unlocked);

        // One milestone at a time. Free shipping is judged on the charged
        // total, the gift on product value, so they need separate bases.
        let label, goal, current;
        if (stranded) {
          label = stranded.product_title + ' is no longer free. Add '
                + money(t1 - spend) + ' or remove it.';
          goal = t1; current = spend;
        } else if (shipCents > 0 && charged < shipCents) {
          label = 'Add ' + money(shipCents - charged) + ' \u2192 free US shipping';
          goal = shipCents; current = charged;
        } else {
          const next = tiers.find(t => spend < t) || 0;
          if (next) {
            const worth = worthAt(box, next);
            label = 'Add ' + money(next - spend) + ' \u2192 free'
                  + (worth ? ' ' + worth : '') + ' gift';
            goal = next; current = spend;
          } else {
            label = box.dataset.unlockedLabel || 'Free gift unlocked, pick yours';
            goal = 0; current = 0;
          }
        }
        if (textEl) textEl.textContent = label;
        show(track, goal > 0);
        if (fill && goal > 0) fill.style.width = Math.min(100, Math.round((current / goal) * 100)) + '%';

        // Tiles are worth screen space once they can be claimed. Until then
        // they sit behind a disclosure so a one-item bag still fits a phone.
        if (picker) paintOpts(picker, spend);
        let tilesOpen;
        if (unlocked) {
          show(peek, false);
          show(picker, true);
          tilesOpen = true;
        } else {
          show(peek, true);
          tilesOpen = !!(peek && peek.getAttribute('aria-expanded') === 'true');
          show(picker, tilesOpen);
        }
        // The separate-parcel note only matters once a gift is on screen.
        show(box.querySelector('.cgift__note'), tilesOpen);
      });
    }

    function bindPeek() {
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-gift-peek]');
        if (!btn) return;
        const box = btn.closest('[data-cart-gift]');
        const picker = box.querySelector('[data-gift-picker]');
        const open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        picker.hidden = open;
        const lbl = btn.querySelector('[data-gift-peek-label]');
        if (lbl) lbl.textContent = open ? 'See the gifts' : 'Hide the gifts';
        box.classList.toggle('is-peeking', !open);
      });
    }

    /* ---- One recommendation ---- */
    function renderUpsell(cart) {
      const boxes = document.querySelectorAll('[data-cart-upsell]');
      if (!boxes.length) return;
      if (!cart.items || !cart.items.length) {
        boxes.forEach(b => { b.hidden = true; });
        return;
      }

      const skip = new Set(cart.items.map(i => i.product_id));
      giftIds().forEach(id => skip.add(id));   // never upsell what we give away
      const seed = cart.items[cart.items.length - 1].product_id;
      if (lastSeed === seed) return;           // no re-fetch on qty tweaks
      lastSeed = seed;

      // How far off the first gift tier we are, used to bias the pick.
      const giftBox = document.querySelector('[data-cart-gift]');
      let gap = 0;
      if (giftBox) {
        const ids = giftIds();
        let spend = 0;
        cart.items.forEach(i => { if (!ids.has(i.product_id)) spend += i.original_line_price; });
        gap = Number(giftBox.dataset.tier1Cents || 0) - spend;
      }

      fetch('/recommendations/products.json?product_id=' + seed + '&limit=12&intent=related')
        .then(r => r.json())
        .then(d => {
          let pool = (d.products || []).filter(p => p.available && !skip.has(p.id));

          // Relevance is the gate. With no order history Shopify's related
          // intent ranks by weak signals, which puts car cases against a
          // squishy. Prefer the same product type when there is one.
          const types = new Set(cart.items.map(i => i.product_type).filter(Boolean));
          const sameType = pool.filter(p => types.has(p.type));
          if (sameType.length) pool = sameType;
          if (!pool.length) { boxes.forEach(b => { b.hidden = true; }); return; }

          // Within that, favour the cheapest item that would clear the gift
          // threshold; failing that, the one that adds the most.
          const clears = pool.filter(p => p.price >= gap).sort((a, b) => a.price - b.price);
          const pick = gap > 0 && clears.length
            ? clears[0]
            : pool.slice().sort((a, b) => b.price - a.price)[0];

          const v = (pick.variants || []).find(x => x.available);
          if (!v) { boxes.forEach(b => { b.hidden = true; }); return; }

          boxes.forEach(box => {
            const img = box.querySelector('[data-upsell-img]');
            if (img) img.src = pick.featured_image ? pick.featured_image + '&width=160' : '';
            box.querySelector('[data-upsell-title]').textContent = pick.title;
            box.querySelector('[data-upsell-price]').textContent = money(v.price);
            const was = box.querySelector('[data-upsell-was]');
            if (was) {
              const hasCompare = v.compare_at_price && v.compare_at_price > v.price;
              was.textContent = hasCompare ? money(v.compare_at_price) : '';
              was.hidden = !hasCompare;
            }
            const btn = box.querySelector('[data-upsell-add]');
            btn.disabled = false;
            btn.textContent = 'Add';
            btn.onclick = () => {
              btn.disabled = true;
              btn.textContent = 'Adding';
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }),
              }).then(() => { lastSeed = null; return afterChange(box); })
                .catch(() => { btn.disabled = false; btn.textContent = 'Add'; });
            };
            box.hidden = false;
          });
        })
        .catch(() => { boxes.forEach(b => { b.hidden = true; }); });
    }

    function render(cart) { renderGift(cart); renderUpsell(cart); renderChip(cart); }
    bindPeek();
    return { render };
  })();

  /* ---------- Cart drawer ---------- */
  const CartDrawer = (() => {
    let drawer, body, itemsEl, emptyEl, footerEl, subtotalEl, countEl, countPills, shippingEl;

    function qs() {
      drawer = document.querySelector('[data-cart-drawer]');
      if (!drawer) return false;
      body = drawer.querySelector('[data-cart-body]');
      itemsEl = drawer.querySelector('[data-cart-items]');
      emptyEl = drawer.querySelector('[data-cart-empty]');
      footerEl = drawer.querySelector('[data-cart-footer]');
      subtotalEl = drawer.querySelector('[data-cart-subtotal]');
      countEl = drawer.querySelector('[data-cart-count]');
      countPills = document.querySelectorAll('[data-cart-count-pill]');
      shippingEl = drawer.querySelector('[data-cart-shipping]');
      return true;
    }

    function open() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cart-drawer-open');
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cart-drawer-open');
    }

    function renderShipping(total) {
      // Delegates to ShipMeter so drawer + cart + product stay in lock-step.
      // If the drawer markup contains the shared [data-ship-meter] snippet,
      // ShipMeter will update it in place. Hide the container only when cart empty.
      ShipMeter.updateAll(total);
    }

    function render(cart) {
      if (!qs()) return;
      const count = cart.item_count || 0;
      if (countEl) countEl.textContent = count;
      countPills.forEach(p => {
        p.textContent = count;
        if (count > 0) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
      });

      if (count === 0) {
        itemsEl.hidden = true;
        emptyEl.hidden = false;
        footerEl.hidden = true;
        ShipMeter.hideDrawerMeter(true);
        ShipMeter.updateAll(0);
        // The reward block and the recommendation have to be told the bag is
        // empty too, or they keep whatever they were showing beforehand.
        CartBoost.render(cart);
        return;
      }
      ShipMeter.hideDrawerMeter(false);
      itemsEl.hidden = false;
      emptyEl.hidden = true;
      footerEl.hidden = false;

      itemsEl.innerHTML = cart.items.map(item => {
        const img = item.image ? '<img src="' + item.image + '&width=160" alt="" class="cart-drawer__item-image">' : '';
        const variant = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<div class="cart-drawer__item-variant">' + item.variant_title + '</div>' : '';
        return (
          '<li class="cart-drawer__item" data-key="' + item.key + '">' +
            img +
            '<div class="cart-drawer__item-main">' +
              '<a class="cart-drawer__item-title" href="' + item.url + '">' + item.product_title + '</a>' +
              variant +
              '<div class="cart-drawer__item-row">' +
                '<div class="cart-drawer__qty">' +
                  '<button type="button" data-qty-dec aria-label="Decrease">-</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-qty-inc aria-label="Increase">+</button>' +
                '</div>' +
                '<div class="cart-drawer__item-price">' + money(item.final_line_price) + '</div>' +
              '</div>' +
              '<button type="button" class="cart-drawer__remove" data-remove>Remove</button>' +
            '</div>' +
          '</li>'
        );
      }).join('');

      subtotalEl.textContent = money(cart.total_price);
      renderShipping(cart.total_price);
      CartBoost.render(cart);
    }

    function updateItem(key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty }),
      }).then(r => r.json()).then(render);
    }

    function bind() {
      if (!qs()) return;

      document.addEventListener('click', (e) => {
        const openBtn = e.target.closest('[data-cart-drawer-open]');
        if (openBtn) {
          e.preventDefault();
          refresh().then(open);
          return;
        }
        if (e.target.closest('[data-cart-drawer-close]')) { close(); return; }

        const li = e.target.closest('.cart-drawer__item');
        if (!li) return;
        const key = li.dataset.key;
        const qtyEl = li.querySelector('.cart-drawer__qty span');
        const qty = parseInt(qtyEl.textContent, 10);

        if (e.target.closest('[data-qty-dec]')) updateItem(key, Math.max(0, qty - 1));
        else if (e.target.closest('[data-qty-inc]')) updateItem(key, qty + 1);
        else if (e.target.closest('[data-remove]')) updateItem(key, 0);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer?.classList.contains('is-open')) close();
      });
    }

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json()).then(cart => { render(cart); return cart; })
        .catch(() => {});
    }

    return { open, close, refresh, bind };
  })();

  /* ---------- Cart page (full /cart view) ----------
     Live qty +/- buttons, input edits, remove link.
     Posts to /cart/change.js and updates line price, subtotal, ship meter.
  --------------------------------------------------- */
  const CartPage = (() => {
    function init() {
      const root = document.querySelector('.cart-page [data-cart-item]');
      if (!root) return;
      const page = document.querySelector('.cart-page');

      const subtotalEl = page.querySelector('[data-cart-subtotal]');
      const totalEl = page.querySelector('[data-cart-total]');
      const pageCountEl = page.querySelector('.cart-page__count');
      const mobileCountEl = page.querySelector('[data-cart-mobile-label]');

      function applyCart(cart) {
        if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
        if (totalEl) totalEl.textContent = money(cart.total_price);
        if (pageCountEl) pageCountEl.textContent = cart.item_count || 0;
        if (mobileCountEl) mobileCountEl.textContent = 'Delivery (' + (cart.item_count || 0) + ')';
        ShipMeter.updateAll(cart.total_price || 0);
        CartBoost.render(cart);
        // Update per-line prices by key
        (cart.items || []).forEach(item => {
          const row = page.querySelector('[data-cart-item][data-key="' + item.key + '"]');
          if (!row) return;
          const priceEl = row.querySelector('[data-cart-item-price]');
          const qtyInput = row.querySelector('[data-cart-qty-input]');
          if (priceEl) priceEl.textContent = money(item.final_line_price);
          if (qtyInput) qtyInput.value = item.quantity;
        });
        // Remove rows that are no longer in cart.
        // Shopify regenerates the hash half of a line key whenever the cart
        // changes, so 52089412223258:d... becomes 52089412223258:1... for a
        // line nobody touched. Comparing whole keys therefore reported every
        // surviving row as gone and emptied the page until a refresh. Match on
        // the variant id, which is stable, and re-sync each row to its new key
        // so later edits still address the right line.
        const remaining = (cart.items || []).map(i => ({ vid: String(i.key).split(':')[0], key: i.key }));
        page.querySelectorAll('[data-cart-item]').forEach(row => {
          const vid = String(row.dataset.key || '').split(':')[0];
          const hit = remaining.findIndex(r => r.vid === vid);
          if (hit === -1) { row.remove(); return; }
          row.dataset.key = remaining[hit].key;
          remaining.splice(hit, 1);
        });
        // If cart became empty, reload to show empty state SSR
        if ((cart.item_count || 0) === 0) { window.location.reload(); }
      }

      function change(key, quantity) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity }),
        }).then(r => r.json()).then(cart => { applyCart(cart); return cart; });
      }

      page.addEventListener('click', (e) => {
        const row = e.target.closest('[data-cart-item]');
        if (!row) return;
        const key = row.dataset.key;
        const input = row.querySelector('[data-cart-qty-input]');
        const current = parseInt(input?.value || '0', 10);

        if (e.target.closest('[data-cart-qty-dec]')) {
          change(key, Math.max(0, current - 1));
        } else if (e.target.closest('[data-cart-qty-inc]')) {
          change(key, current + 1);
        } else if (e.target.closest('[data-cart-item-remove]')) {
          change(key, 0).then(() => row.remove());
        }
      });

      // Debounced direct-input edits
      let t;
      page.addEventListener('input', (e) => {
        const input = e.target.closest('[data-cart-qty-input]');
        if (!input) return;
        const row = input.closest('[data-cart-item]');
        const key = row?.dataset.key;
        if (!key) return;
        clearTimeout(t);
        t = setTimeout(() => {
          const q = Math.max(0, parseInt(input.value || '0', 10));
          change(key, q);
        }, 450);
      });

      // Liquid can render before automatic discounts settle. Hydrate the page
      // from the same cart JSON used by the drawer so both surfaces always show
      // the same charged total on first paint.
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json())
        .then(applyCart)
        .catch(() => {});
    }
    return { init };
  })();

  // Expose to window so Round-2 quick-add can refresh drawer + ship meter.
  window.CartDrawer = CartDrawer;
  window.ShipMeter = ShipMeter;

  document.addEventListener('DOMContentLoaded', () => {
    initVariantSync();
    initStickyATC();
    initAjaxATC();
    CartDrawer.bind();
    CartDrawer.refresh(); // triggers ShipMeter.updateAll via renderShipping
    ShipMeter.init();     // fallback hydrate if cart drawer not on page
    CartPage.init();      // live qty edits on /cart
    if (document.querySelector('.cart-page [data-cart-item]')) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(r => r.json()).then(CartBoost.render).catch(() => {});
    }
  });
})();

/* ============================================================
   TODO FUN - Reveal-on-scroll (IntersectionObserver)
   ============================================================ */
(function () {
  function initReveal() {
    const els = document.querySelectorAll('.reveal-on-scroll');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          // Stagger children a touch for lists
          const delay = parseFloat(e.target.dataset.revealDelay || '0');
          e.target.style.transitionDelay = delay + 'ms';
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(el => io.observe(el));

    // Also stagger direct children of complete-series grid and trust strip
    document.querySelectorAll('.complete-series__grid').forEach(grid => {
      Array.from(grid.children).forEach((c, i) => {
        c.classList.add('reveal-on-scroll');
        c.dataset.revealDelay = (i * 80);
        io.observe(c);
      });
    });
    document.querySelectorAll('.trust-badges').forEach(row => {
      Array.from(row.children).forEach((c, i) => {
        c.classList.add('reveal-on-scroll');
        c.dataset.revealDelay = (i * 70);
        io.observe(c);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();

/* ============================================================
   TODO FUN - Round 2: Quick-add + collection sort + toast
   ============================================================ */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Toast ---------- */
  const Toast = (() => {
    let el;
    function ensure() {
      if (el) return el;
      el = document.createElement('div');
      el.className = 'qa-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
      return el;
    }
    function show(html, ms) {
      const node = ensure();
      node.innerHTML = '<span class="qa-toast__check">\u2713</span>' + html;
      node.classList.add('is-visible');
      clearTimeout(node._t);
      node._t = setTimeout(() => node.classList.remove('is-visible'), ms || 3200);
    }
    return { show };
  })();

  /* ---------- Quick-add from product cards ---------- */
  function initQuickAdd() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.quickAdd;
      const label = btn.dataset.quickAddLabel || 'Item';
      if (!variantId) return;

      btn.classList.add('is-loading');
      const textEl = btn.querySelector('.product-card__quick-add-text');
      const originalText = textEl?.textContent;
      if (textEl) textEl.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      }).then(r => {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(() => {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (textEl) textEl.textContent = 'Added';
        Toast.show(
          '<span class="qa-toast__message"><strong>' + label + '</strong><span>Added to bag</span></span><a href="#" data-open-cart-from-toast>View bag</a>',
          3200
        );
        // Sync drawer silently
        if (window.CartDrawer && window.CartDrawer.refresh) {
          window.CartDrawer.refresh();
        } else {
          // Fallback: fire a cart refresh so ShipMeter updates
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(r => r.json())
            .then(cart => {
              if (window.ShipMeter) window.ShipMeter.updateAll(cart.total_price);
            });
        }
        setTimeout(() => {
          btn.classList.remove('is-added');
          if (textEl && originalText) textEl.textContent = originalText;
        }, 2000);
      }).catch(() => {
        btn.classList.remove('is-loading');
        if (textEl && originalText) textEl.textContent = originalText;
        Toast.show('Could not add. Try the product page.', 3200);
      });
    });

    // Toast -> open cart drawer
    document.addEventListener('click', (e) => {
      const openLink = e.target.closest('[data-open-cart-from-toast]');
      if (!openLink) return;
      e.preventDefault();
      const opener = document.querySelector('[data-cart-drawer-open]');
      if (opener) opener.click();
    });
  }

  /* ---------- Collection sort: auto-submit on change ---------- */
  function initCollectionSort() {
    const select = document.querySelector('[data-collection-sort-select]');
    if (!select) return;
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initQuickAdd();
    initCollectionSort();
  });
})();

/* ============================================================
   TODO FUN - Predictive search (uses /search/suggest.json)
   ============================================================ */
(function () {
  const input = document.querySelector('[data-predictive-search-input]');
  if (!input) return;
  const results = document.querySelector('[data-predictive-results]');
  const productsSection = document.querySelector('[data-predictive-products]');
  const productsList = document.querySelector('[data-predictive-products-list]');
  const queriesSection = document.querySelector('[data-predictive-queries]');
  const queriesList = document.querySelector('[data-predictive-queries-list]');
  const empty = document.querySelector('[data-predictive-empty]');
  const emptyTerm = document.querySelector('[data-predictive-empty-term]');
  const viewAll = document.querySelector('[data-predictive-view-all]');
  const viewAllTerm = document.querySelector('[data-predictive-view-all-term]');
  const defaultContent = document.querySelector('[data-search-default]');
  if (!results || !productsList) return;

  let timer = null;
  let abortCtl = null;

  const money = (cents) => {
    try { return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const escapeHtml = (s) => String(s || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  function showDefault() {
    results.hidden = true;
    if (defaultContent) defaultContent.hidden = false;
  }
  function showResults() {
    results.hidden = false;
    if (defaultContent) defaultContent.hidden = true;
  }

  function render(data, term) {
    const products = (data.resources && data.resources.results && data.resources.results.products) || [];
    const queries = (data.resources && data.resources.results && data.resources.results.queries) || [];

    if (products.length === 0 && queries.length === 0) {
      productsSection.hidden = true;
      queriesSection.hidden = true;
      empty.hidden = false;
      emptyTerm.textContent = term;
      viewAll.hidden = true;
      return;
    }
    empty.hidden = true;

    if (products.length) {
      productsSection.hidden = false;
      productsList.innerHTML = products.slice(0, 6).map(p => {
        const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        const price = p.price != null ? money(parseFloat(p.price) * 100) : '';
        return `
          <a class="predictive-product" href="${escapeHtml(p.url)}">
            ${img ? `<img class="predictive-product__img" src="${escapeHtml(img)}" alt="" loading="lazy" width="56" height="56">` : '<div class="predictive-product__img predictive-product__img--ph"></div>'}
            <div class="predictive-product__meta">
              <div class="predictive-product__title">${escapeHtml(p.title)}</div>
              <div class="predictive-product__price">${escapeHtml(price)}</div>
            </div>
          </a>`;
      }).join('');
    } else {
      productsSection.hidden = true;
    }

    if (queries.length) {
      queriesSection.hidden = false;
      queriesList.innerHTML = queries.slice(0, 4).map(q => `
        <a class="predictive-query" href="/search?q=${encodeURIComponent(q.text)}">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
          <span>${escapeHtml(q.text)}</span>
        </a>`).join('');
    } else {
      queriesSection.hidden = true;
    }

    viewAll.hidden = false;
    viewAllTerm.textContent = term;
    viewAll.href = '/search?q=' + encodeURIComponent(term);
  }

  async function fetchPredictive(term) {
    if (abortCtl) abortCtl.abort();
    abortCtl = new AbortController();
    const url = `/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last`;
    try {
      const r = await fetch(url, { signal: abortCtl.signal });
      if (!r.ok) throw new Error('bad response');
      const data = await r.json();
      showResults();
      render(data, term);
    } catch (e) {
      if (e.name !== 'AbortError') { /* silent; leave default visible */ }
    }
  }

  input.addEventListener('input', () => {
    const term = input.value.trim();
    clearTimeout(timer);
    if (term.length < 2) { showDefault(); return; }
    timer = setTimeout(() => fetchPredictive(term), 180);
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length >= 2) showResults();
  });
})();

/* ============================================================
   TODO FUN - Product recommendations (async fetch)
   ============================================================ */
(function () {
  const el = document.querySelector('[data-product-recommendations]');
  if (!el) return;
  const grid = el.querySelector('[data-recommendations-grid]');
  const url = el.dataset.url;
  if (!grid || !url) return;

  el.classList.add('is-loading');
  fetch(url)
    .then(r => r.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const inner = doc.querySelector('.shopify-section') || doc.body;
      const cards = inner.querySelectorAll('.product-card');
      if (!cards.length) { el.remove(); return; }
      grid.innerHTML = '';
      cards.forEach((c, i) => {
        if (i < 4) grid.appendChild(c);
      });
      el.classList.remove('is-loading');
      el.classList.add('is-loaded');
    })
    .catch(() => { el.remove(); });
})();
